var headroomHeader = document.getElementById("site-navigation-wrapper");
// construct an instance of Headroom, passing the element
var headroom  = new Headroom(headroomHeader);
// initialise
headroom.init();



// WEBPACK FOOTER //
// ./assets/js/navigation.js